<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Edit stock
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      div.d-flex.mt-3
        div
          .text-lg.font-semibold.neutral700--text {{ product.name }}
          .text-sm.font-semibold.neutral500--text(v-if="product.uom") UOM: {{ product.uom }}
        v-spacer
        .text-md.font-semibold.neutral700--text Changes ({{ stock.change }})
      v-form(ref="form")
        //- template(v-if="!addInvoice")
          div.text-sm.font-semibold.neutral500--text.mt-6 Invoice
          v-row.my-0(align="center")
            v-col(cols="8")
              invoice-dropdown(v-model="invoice" show-person-in-charge)
            v-col(cols="1")
              div.text-sm.font-semibold.neutral700--text.text-center OR
            v-col
              y-button(label="Add new invoice" underline color="neutral700" size="md" button-class="px-3" @click="addInvoice = true; invoice = {}")
        //- template(v-else)
          div.d-flex.align-center.mt-4
            div.text-sm.font-semibold.neutral500--text Invoice
            v-spacer
            y-button(label="Select from existing seller" underline color="neutral700" size="sm" button-class="px-3" @click="addInvoice = false; ; invoice = {}")
          v-row.my-0
            v-col
              div.text-sm.font-semibold.neutral500--text Invoice number
              v-text-field.text-sm.mt-2.round-xl(v-model="stockInvoiceNo" placeholder="Invoice number" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
            v-col
              div.text-sm.font-semibold.neutral500--text Invoice date
              y-dialog(v-model="showInvoicePicker" width='320px' persistent)
                template(v-slot:activator='{ on }')
                  v-text-field.text-sm.mt-2.round-xl.date-field(v-model="invoiceDateField" placeholder="Invoice date" outlined dense height="48" readonly :rules="rules.not_empty" hide-details="auto" v-on="on" clearable)
                    template(v-slot:append)
                      eva-icon(name="calendar-outline" fill="#848484")
                v-card
                  v-card-text.px-2.pt-2.pb-0
                    yc-date-picker(:parentDate.sync="selectedInvoiceDate" color="info")
                  v-card-actions.px-4.pb-4
                    v-row(no-gutters)
                      v-col.pr-2
                        v-btn.button-sm(color="basic700" block dark outlined depressed @click="showInvoicePicker = false") {{ $t('cancel') }}
                      v-col.pl-2
                        v-btn.button-sm(color="info500" block depressed dark @click="pickDate('invoiceDateField', 'showInvoicePicker', selectedInvoiceDate)") {{ $t('select') }}
            v-col
              div.text-sm.font-semibold.neutral500--text Sold by
              medication-sold-by-dropdown.mt-2(v-model="seller" show-add-seller :error="showSellerError" @closed="showSellerError = false")
        v-row.my-0
          v-col
            div.text-sm.font-semibold.neutral500--text Stock cost
            v-text-field.text-sm.mt-2.round-xl(v-model="stockCost" placeholder="100" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details="auto" @input="updateCost")
          v-col
            div.text-sm.font-semibold.neutral500--text Cost per item
            v-text-field.text-sm.mt-2.round-xl(v-model="costPerItem" placeholder="0.00" background-color="neutral300" outlined dense height="48" type="number" :prefix="$currency.symbol" disabled hide-details="auto")
        div.d-flex.align-center.mb-2
          v-icon.mr-1(size="20") mdi-information-outline
          div.text-xs.neutral700--text Fill up stock cost to get an accurate cost per item.
        v-row.my-0
          v-col
            div.text-sm.font-semibold.neutral500--text Batch number
            v-text-field.text-sm.mt-2.round-xl(v-model="stockBatchNo" placeholder="Batch number" outlined dense height="48" hide-details="auto")
          v-col
            div.text-sm.font-semibold.neutral500--text Expiry date
            y-dialog(v-model="showExpiredPicker" width='320px' persistent)
              template(v-slot:activator='{ on }')
                v-text-field.text-sm.mt-2.round-xl.date-field(v-model="expiryDateField" placeholder="Expiry date" outlined dense height="48" readonly hide-details="auto" v-on="on" clearable)
                  template(v-slot:append)
                    eva-icon(name="calendar-outline" fill="#848484")
              v-card
                v-card-text.px-2.pt-2.pb-0
                  yc-date-picker(:parentDate.sync="selectedExpiryDate" color="info")
                v-card-actions.px-4.pb-4
                  v-row(no-gutters)
                    v-col.pr-2
                      v-btn.button-sm(color="basic700" block dark outlined depressed @click="showExpiredPicker = false") {{ $t('cancel') }}
                    v-col.pl-2
                      v-btn.button-sm(color="info500" block depressed dark @click="pickDate('expiryDateField', 'showExpiredPicker', selectedExpiryDate)") {{ $t('select') }}
        v-row.my-0
          v-col
            div.text-sm.font-semibold.neutral500--text Remarks
            v-textarea.text-sm.mt-2.round-xl(v-model="remarks" placeholder="Write your remarks here" outlined rows="3" hide-details="auto")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
import InvoiceDropdown from '@/components/clinic/inventory/InvoiceDropdown.vue'

export default {
  components: { MedicationSoldByDropdown, InvoiceDropdown },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showInvoicePicker: false,
      showExpiredPicker: false,
      showSellerError: false,
      addInvoice: false,
      stockChange: null,
      stockCost: null,
      stockBatchNo: null,
      stockInvoiceNo: null,
      costPerItem: null,
      selectedInvoiceDate: null,
      selectedExpiryDate: null,
      invoiceDateField: null,
      expiryDateField: null,
      remarks: null,
      seller: {},
      invoice: {},
      oriInvoice: {},
      actions: [
        { text: 'Stock received', value: 'received' },
        { text: 'Inventory re-count', value: 're-count' },
        { text: 'Damage', value: 'damage' },
        { text: 'Theft', value: 'theft' },
        { text: 'Loss', value: 'loss' },
        { text: 'Stock return', value: 'return' },
        { text: 'Clinic use', value: 'use' },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0|| `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.stockChange = this.stock.change
    this.stockCost = Number(this.stock.cost) / Number(this.$currency.multiplier)
    this.stockBatchNo = this.stock.batch_no
    this.selectedExpiryDate = this.stock.expiry_date
    this.remarks = this.stock.remarks
    if (this.stock.expiry_date) {
      this.expiryDateField = this.$options.filters.humanizeDate(this.stock.expiry_date)
    }
    if (this.stock.invoice) {
      this.oriInvoice = JSON.parse(JSON.stringify(this.stock.invoice))
      this.invoice = this.stock.invoice
    }
    this.updateCost()
  },
  methods: {
    ...mapActions(['showMessage']),
    async saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      // if (this.addInvoice && Object.keys(this.seller).length == 0) {
      //   this.showSellerError = true
      //   return
      // }
      this.isLoading = true
      let data = {
        cost: Math.round(Number(this.stockCost) * Number(this.$currency.multiplier)),
        batch_no: this.stockBatchNo,
        expiry_date: this.selectedExpiryDate,
        remarks: this.remarks,
      }
      if (!this.expiryDateField) { data.expiry_date = null }
      if (!this.invoice.id && !this.addInvoice) {
        data.invoice_no = null
        data.invoice_date = null
        data.manufacturer = null
      }
      try {
        await this.$axios.patch(`/products/${this.product.id}/inventories/${this.stock.id}`, data)
        if (this.oriInvoice.id) {
          if (this.invoice.id && this.invoice.id === this.oriInvoice.id) {
            this.$emit('update')
            return
          }
          let itemObject = this.oriInvoice.items.find(f => f.product_inventory.id === this.stock.id)
          if (itemObject) {
            await this.$axios.delete(`/clinics/${this.company.slug}/inventory_invoices/${this.oriInvoice.id}/items/${itemObject.id}/`)
          }
        }
        if (this.invoice.id) {
          const payload = {
            product_inventory_id: this.stock.id
          }
          await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${this.invoice.id}/items/`, payload)
        } else if (this.addInvoice) {
          let payload = {
            invoice_no: this.stockInvoiceNo,
            record_date: this.selectedInvoiceDate,
            seller: this.seller.sold_by,
            product_inventory_ids: [this.stock.id]
          }
          await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/`, payload)
        }
        this.$emit('update')
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    createSeller (seller) {
      this.isFetching = true
      let data = {
        company: this.company.id,
        field: 'medication.sold_by',
        value: seller.sold_by,
        enabled: true,
        extra_data: { ...seller }
      }
      this.$axios.post('/options', data)
        .catch(() => {})
    },
    pickDate (field, picker, date) {
      this[field] = this.$options.filters.humanizeDate(date)
      this[picker] = false
    },
    updateCost () {
      let stock = this.stockChange || 0
      let cost = this.stockCost || 0
      let costPerItem = Number(cost) / (Number(stock) || 1)
      this.costPerItem = costPerItem.toFixed(2)
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>